var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepsSepDis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 5,
    viewBox: "0 0 125 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_1025",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 1025",
    transform: "translate(-167 -803)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_32",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 32",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(167 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_43",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 43",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(239 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_34",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 34",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(191 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_41",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 41",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(263 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_37",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 37",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(215 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_39",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 39",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(287 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_33",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 33",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(179 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_42",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 42",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(251 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_35",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 35",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(203 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_40",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 40",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(275 803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_36",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 36",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(227 803)",
    fill: "#e0e0e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsSepDis);
export default __webpack_public_path__ + "static/media/steps_sep_dis.a3c3d391401422b7fc7d7bf89039cba1.svg";
export { ForwardRef as ReactComponent };